export default __webpack_public_path__ + "static/media/deal.21b7a1e8.mp3";